/**
 * @generated SignedSource<<1e80d2c0960ab50951b9f5e6e5643f96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CatalogMenuBar_catalogPage$data = {
  readonly embeddedFile: {
    readonly filePath: string | null;
  } | null;
  readonly file: {
    readonly filePath: string | null;
  } | null;
  readonly images: {
    readonly pageCount: number | null;
    readonly singlePageDimensions: {
      readonly height: number;
      readonly width: number;
    };
  } | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"CatalogPageNumber_catalogPage" | "ShareOptionsPanel_catalogPage">;
  readonly " $fragmentType": "CatalogMenuBar_catalogPage";
};
export type CatalogMenuBar_catalogPage$key = {
  readonly " $data"?: CatalogMenuBar_catalogPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"CatalogMenuBar_catalogPage">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "filePath",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CatalogMenuBar_catalogPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CatalogFileModuleType",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CatalogFileModuleType",
      "kind": "LinkedField",
      "name": "embeddedFile",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CatalogImagesType",
      "kind": "LinkedField",
      "name": "images",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CatalogImagesDimensions",
          "kind": "LinkedField",
          "name": "singlePageDimensions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CatalogPageNumber_catalogPage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShareOptionsPanel_catalogPage"
    }
  ],
  "type": "CatalogPage",
  "abstractKey": null
};
})();

(node as any).hash = "fb2f596c1ecc6e71017e4762f19d0b7b";

export default node;
